import { Marker as MarkerL, MapContainer, TileLayer, Popup, Polyline, GeoJSON, useMap } from "react-leaflet";
import { nodePoints } from '../../features/api_node_points/apiNodePointsSlice';
import { routerActions, selectRoute } from '../../features/router/routerSlice';
// import 'https://rawgit.com/jieter/Leaflet.encoded/master/Polyline.encoded.js';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from "react";
import geoJson from '../../mocks/nodemap-enkartur.json';
import "leaflet.vectorgrid";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import L from 'leaflet';
import './drawMap.css';
import { NodePointMarker } from '../NodePointMarker';
import { Coordinate, PathSegment, NodePoint } from '../../types/types'
import configService from '../../services/configService';
import * as polyUtil from 'polyline-encoded';
import { poiService } from '../../services/poiService';
import MarkerClusterGroup from "react-leaflet-cluster";

interface MapProps {
  isMapClicked: boolean;
  showSnackbar: Function;
  currentSequence: string[];
  onMarkerClick: (nodeId: string) => void;
  pathCoords: Array<PathSegment>
  setPathCoords: React.Dispatch<React.SetStateAction<Array<PathSegment>>>;
  setCurrentSequence: React.Dispatch<React.SetStateAction<string[]>>;
  onPointInterestSelected: (pointInterestId: string) => void;
  pointInterestSelected?: string | null;
};


export const Map: React.FC<MapProps> = ({
  showSnackbar,
  isMapClicked,
  onMarkerClick,
  currentSequence,
  pathCoords,
  setPathCoords,
  setCurrentSequence,
  onPointInterestSelected,
  pointInterestSelected

}) => {
  const nodes = useSelector(nodePoints) as NodePoint[] | null;
  const Lx = L as any as Lx.L;
  const dispatch = useDispatch();
  const routeSegment = useSelector(selectRoute);
  const [geoJsonData, setGeoJsonData] = useState<any>(null);
  // const map_url = "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
  const map_url = "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibmllbHNoaSIsImEiOiJjbWYyZWVxZ20yOXVoMmxxeGJ3ODJ4MzJyIn0.h6S8tI3hx1Fi87NUsJAbAQ"
  const [showItinerary, setShowItinerary] = useState(false)
  const [position, setPosition] = useState<L.LatLng | null>(null);
  const [currentZoom, setCurrentZoom] = useState(13);
  const [tenantPois, setTenantPois] = useState<NodePoint[]>([]);

  useEffect(() => {
    const coordinates: Array<Coordinate> = [];
    if (routeSegment) {

      const distance = routeSegment.routes[0].distance;

      const latlngs = polyUtil.decode(routeSegment.routes[0].geometry);

      for (const [lat, lng] of latlngs) {
        coordinates.push({ lat, lng })
      }
      const newPath: PathSegment = {
        distance: distance,
        path: coordinates
      }
      setPathCoords([...pathCoords, newPath]);
    }

  }, [routeSegment]);

  useEffect(() => {
    setGeoJsonData(geoJson);

  }, []);

  useEffect(() => {
    const loadTenantPois = async () => {
      await configService.initialize();
      const tenantId = configService.getConfig().tenantId;
      const pois = await poiService.getTenantPois(tenantId);
      setTenantPois(pois);
    };

    loadTenantPois();
  }, []);




  useEffect(() => {
    if (currentSequence.length >= 2) {
      // Clear the last polyline if we removed a marker
      if (pathCoords.length > currentSequence.length - 1) {
        setPathCoords(pathCoords.slice(0, -1));
        return;
      }
      const lastNodeId = currentSequence[currentSequence.length - 1];
      const prevNodeId = currentSequence[currentSequence.length - 2];

      const lastNode = geoJsonData?.features.find((feature: any) =>
        feature.properties?.node === lastNodeId
      );
      const prevNode = geoJsonData?.features.find((feature: any) =>
        feature.properties?.node === prevNodeId
      );

      if (lastNode && prevNode) {
        dispatch(
          routerActions.fetchRoute({
            original: [prevNode.geometry.coordinates[1], prevNode.geometry.coordinates[0]],
            destination: [lastNode.geometry.coordinates[1], lastNode.geometry.coordinates[0]],
          })
        );

      }
    }
    if (currentSequence.length === 1) {
      setPathCoords([]);
    }
  }, [currentSequence]);


  useEffect(() => {

  }, [pathCoords]);


  // create a function that takes as a parameter the node.id in 'nodes' and give as an output the lat and long 
  const getCenterOfMap = (id: string) => {
    nodes?.forEach((node) => {
      if (node.id === id) {
        setPosition(new L.LatLng(node.lat, node.lon));
      }
    });
  }

  // Call API on component mount with initial center
  // useEffect(() => {
  //   const fetchPlaces = async () => {
  //     const places = await getPlacesByLocation(centerMap);
  //     setPlaces(places);
  //   };
  //   fetchPlaces();
  // }, []);

  // Component to handle map panning
  const MapController = () => {
    const map = useMap();

    useEffect(() => {
      const handleZoomEnd = () => {
        setCurrentZoom(map.getZoom());
        console.log('zoom:', map.getZoom())
      };

      map.on('zoomend', handleZoomEnd);

      return () => {
        map.off('zoomend', handleZoomEnd);
      };
    }, [map]);


    return null;
  };

  useEffect(() => {
    console.log('1')
    if (pointInterestSelected) {
      console.log('1.2')
      getCenterOfMap(pointInterestSelected);
    }
  }, [pointInterestSelected]);

  // Get map center from config
  const [mapCenterLat, mapCenterLng] = configService.getMapCenter();
  const centerMap = { lat: mapCenterLat, lng: mapCenterLng };
  const defaultZoom = configService.getDefaultZoom();

  return (
    <div className="map-container">
      <MapContainer center={centerMap} zoom={defaultZoom} style={{ height: '100%', width: '100%' }}>
        <MapController />
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright%22%3EOpenStreetMap</a> contributors'
          url={map_url}
        />

        {geoJsonData?.features.map((feature: any) => {
          if (feature.properties?.junction) {
            return (
              <MarkerL
                key={feature.properties.id}
                position={[feature.geometry.coordinates[1], feature.geometry.coordinates[0]]}

                icon={L.divIcon({
                  className: currentSequence.includes(feature.properties.node) ? 'markerSelected' : 'map-marker',
                  iconSize: [25, 25],
                  popupAnchor: [1, -34],
                  shadowSize: [41, 41],
                  html: `<div>${feature.properties.node}</div>`,
                })}
                eventHandlers={{
                  click: () => {
                    onMarkerClick(feature.properties.node)
                  }
                }}
              />
            );
          }
          return null;
        })}

        {geoJsonData?.features.map((feature: any) => {
          if (feature.geometry.type === 'LineString') {
            const coordinates = feature.geometry.coordinates.map((coord: any) => [coord[1], coord[0]]);
            return (
              <Polyline
                key={feature.properties?.id || Math.random()}
                positions={coordinates}
                color="black"
                weight={4}
                opacity={1}
              />
            );
          }
          return null;
        })}

        {tenantPois.length > 0 && (
          <MarkerClusterGroup
            chunkedLoading
            disableClusteringAtZoom={15}
            spiderfyOnMaxZoom
            showCoverageOnHover={false}
            maxClusterRadius={48}
          >
            {tenantPois.map((poi) => (
              <NodePointMarker
                key={poi.id}
                node={poi}
                currentZoom={currentZoom}
                isMapClicked={isMapClicked}
              />
            ))}
          </MarkerClusterGroup>
        )}

        {pathCoords.map((point) => (
          <Polyline color={"#9af873"} opacity={0.7} weight={6} positions={point.path} eventHandlers={{
            mouseover: (event) => event.target.openPopup(),
          }} >
          </Polyline>
        ))}
      </MapContainer>

    </div>
  );
};
